const axios = require('axios');

(() => {
  var formNum = 1;
  const newUserRegistrationCheckBox = '.new-camping-reservation-user-registration-check-box'
  const editUserRegistrationCheckBox = '.edit-camping-reservation-user-registration-check-box'
  const newPasswordForm = '.camping_reservation_new_password_form'
  const editPasswordForm = '.camping_reservation_edit_password_form'
  const password = '.camping-registration-password'
  const passwordConfirmation = '.camping-registration-password-confirmation'

  const init = () => {
    if (location.href.indexOf('customer/camping/guest') < 1 ) {
      return
    }

    path = process.env.JS_BASE_URL + 'customer/camping/guest/new'
    if (location.pathname === path && localStorage.getItem('initial_user_registration_modal') === null) {
      $('#camping-login-confirmation-modal').click();
      localStorage.setItem('initial_user_registration_modal', 'on');
    } else if (location.pathname !== path && localStorage.getItem('initial_user_registration_modal') === 'on') {
      localStorage.removeItem('initial_user_registration_modal');
    }

    if ($('#data-camping-companions').data('camping-companions') != null && $('#data-camping-companions').data('camping-companions').length > 1) {
      var campingCompanions = $('#data-camping-companions').data('camping-companions');
      formNum = campingCompanions.length;
    }

    $(newPasswordForm).hide();
    $('body').on('click', newUserRegistrationCheckBox, toggleNewPasswordForm);
    toggleNewPasswordForm();

    if ($(editUserRegistrationCheckBox).prop('checked')) {
      $(editPasswordForm).show();
    } else {
      $(editPasswordForm).hide();
    }
    $('body')
      .on('click', editUserRegistrationCheckBox, toggleEditPasswordForm)
      .on('change', '.js-check-companion', checkCompanion)
      .on('click', '.js-user-add', addCompanionField);
  }

  const addCompanionField = e => {
    const field = `<div class="camping-subscription-email mb-2"><input placeholder="例：mail@ushinohiroba.com" maxlength="250" class="js-check-companion" size="250" type="text" name="camping_guest_registration_form[companions[${formNum}]]" id="camping_guest_registration_form_companions[${formNum}]" /><div class="check-email hide"><span></span></div><div class="error-message hide"><div class="invalid-camping-subscriber-email"><div class="email-icon"></div><div class="text">入力されたメールアドレスは定額キャンプに加入されていません。</div></div></div></div>`
    formNum++;
    $(e.currentTarget).before(field);
  }

  const checkCompanion = e => {
    e.preventDefault();
    const target = e.currentTarget
    const val = $(target).val()
    axios.get(process.env.JS_BASE_URL + 'api/v1/camping/camping_subscriptions', {
      params: {
        email: val
      }
    })
    .then(response => {
      console.log(response.data)
      if (response.data['result'] == 'ok') {
        $(target).siblings('.check-email').removeClass('hide')
        $(target).siblings('.error-message').addClass('hide')
      }
      else {
        $(target).siblings('.check-email').addClass('hide')
        $(target).siblings('.error-message').removeClass('hide')
      }
    })
  }

  const toggleNewPasswordForm = () => {
    if ($(newUserRegistrationCheckBox).prop('checked')) {
      $(password).prop('disabled', false);
      $(passwordConfirmation).prop('disabled', false);
      $(newPasswordForm).fadeIn();
    } else {
      $(password).prop('disabled', true);
      $(passwordConfirmation).prop('disabled', true);
      $(newPasswordForm).fadeOut();
    }
  }

  const toggleEditPasswordForm = () => {
    if ($(editUserRegistrationCheckBox).prop('checked')) {
      $(password).prop('disabled', false);
      $(passwordConfirmation).prop('disabled', false);
      $(editPasswordForm).fadeIn();
    } else {
      $(password).prop('disabled', true);
      $(passwordConfirmation).prop('disabled', true);
      $(editPasswordForm).fadeOut();
    }
  }
  $(init);
})();


